import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tag,
} from 'antd'
import React, { useEffect, useState } from 'react'
import DaumPostcodeEmbed from 'react-daum-postcode'

import dayjs from 'dayjs'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import * as XLSX from 'xlsx'
import orderApi from '../../api/order.api'
import promotionApi from '../../api/promotion.api'
import pushApi from '../../api/push.api'
import ExcelUploadBodyComponent from '../../components/sales/ExcelUploadBodyComponent'
import OrderDetailComponent from '../../components/sales/OrderDetailComponent'
import OrderStatusQuickMenu from '../../components/sales/OrderStatusQuickMenu'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/sales.module.scss'
import statusUtil from '../../utils/status'

const numberReg = /^[0-9]*$/

const OrderConfirmPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [mediaResult, setMediaResult] = useState(null)
  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    searchType: 'paymentCreatedAt',
    searchStatus: 'paid',
    searchDetailType: '',
    searchDetail: '',
    searchOrderId: '',
    searchProductName: '',
    funnel: 0,
    name: '',
    phone: '',
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
  })
  const [orderType, setOrderType] = useState('paymentCreatedAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [selectedRow, setSelectedRow] = useState([])
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([])
  const [totalOrderList, setTotalOrderList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [editDeliveryInfo, setEditDeliveryInfo] = useState({})
  const [customerDeliveryInfo, setCustomerDeliveryInfo] = useState({})
  const [editCancelReason, setEditCancelReason] = useState({
    cancelReason: null,
    refundBank: null,
  })
  const [orderDetail, setOrderDetail] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPostalCodeModalOpen, setIsPostalCodeModalOpen] = useState(false)
  const [isDeliveryShippingModalOpen, setIsDeliveryShippingModalOpen] =
    useState(false)
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)
  const [isCancelRequestModalOpen, setIsCancelRequestModalOpen] =
    useState(false)
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false)
  const [validation, setValidation] = useState(false)
  const [uploadExcelDataHeader, setUploadExcelDataHeader] = useState([])
  const [uploadExcelData, setUploadExcelData] = useState([])
  const [uploadExcelDataError, setUploadExcelDataError] = useState([])
  const [uploadExcelName, setUploadExcelName] = useState('')
  const [showWarningModal, setShowWarningModal] = useState(false)

  const searchDateItems = [
    { searchText: '결제일', searchType: 'paymentCreatedAt' },
    { searchText: '발송일', searchType: 'shipDate' },
    { searchText: '주문일시', searchType: 'orderCreatedAt' },
    { searchText: '구매확정일', searchType: 'completeDate' },
  ]
  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
  ]
  const orderStatusItems = [
    { label: '전체', value: 'total' },
    // {label: '입금대기', value: 'ready'},
    { label: '입금완료', value: 'paid' },
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    { label: '배송준비중', value: 'delivery_ready' },
    { label: '배송중', value: 'delivery_shipping' },
    { label: '배송완료', value: 'delivery_complete' },
    { label: '구매확정', value: 'complete' },
    { label: '취소요청', value: 'cancel_request' },
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    { label: '취소완료', value: 'cancel_complete' },
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ]
  const funnelStatusItems = [
    { label: '전체', value: 0 },
    { label: '검색', value: 1 },
    { label: '전화주문', value: 4 },
    // { label: '인플루언서', value: 2 },
    // { label: '셀러', value: 5 },
    { label: '공동구매', value: 3 },
  ]
  const cancelReasonItems = [
    { label: '상품품절', value: '상품품절' },
    { label: '배송지연', value: '배송지연' },
    { label: '서비스 불만족', value: '서비스 불만족' },
    { label: '구매의사취소', value: '구매의사취소' },
    { label: '색상 및 사이즈 변경', value: '색상 및 사이즈 변경' },
    { label: '다른 상품 잘못 주문', value: '다른 상품 잘못 주문' },
    { label: '상품정보 상이', value: '상품정보 상이' },
  ]
  const bankCodeItems = [
    { label: 'KB국민은행', value: '04' },
    { label: 'SC제일은행', value: '23' },
    { label: '경남은행', value: '39' },
    { label: '광주은행', value: '34' },
    { label: '기업은행', value: '03' },
    { label: '농협', value: '11' },
    { label: '대구은행', value: '31' },
    { label: '부산은행', value: '32' },
    { label: '산업은행', value: '02' },
    { label: '새마을금고', value: '45' },
    { label: '수협', value: '07' },
    { label: '신한은행', value: '88' },
    { label: '신협', value: '48' },
    { label: '외환은행', value: '81' },
    { label: '우리은행', value: '20' },
    { label: '우체국', value: '71' },
    { label: '전북은행', value: '37' },
    { label: '축협', value: '12' },
    { label: '카카오뱅크', value: '90' },
    { label: '케이뱅크', value: '89' },
    { label: '하나은행', value: '81' },
    { label: '한국씨티은행', value: '27' },
    { label: '토스뱅크', value: '92' },
  ]
  const orderPair = {
    paymentCreatedAt: '결제일순',
    orderId: '주문번호순',
    // shipDate: '발송일순',
    createdAt: '주문일시순',
  }
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      for (const row of selectedRows) {
        if (
          !Object.prototype.hasOwnProperty.call(
            editDeliveryInfo,
            row.orderDetailId,
          )
        ) {
          editDeliveryInfo[row.orderDetailId] = {
            orderId: row.orderId,
            orderDetailId: row.orderDetailId,
            orderDetailStatus: 'delivery_shipping',
            deliveryCompany: row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate:
              row.shipDate === null || row.shipDate === ''
                ? dayjs()
                : dayjs(row.shipDate),
          }
        }
      }
      let difference = Object.keys(editDeliveryInfo).filter(
        (orderDetailKey) => !selectedRowKeys.includes(parseInt(orderDetailKey)),
      )
      if (difference?.length !== 0) {
        for (const orderDetailKey of difference) {
          delete editDeliveryInfo[orderDetailKey]
        }
      }
      setSelectedRowKey(selectedRowKeys)
      setSelectedRow(selectedRows)
    },
  }

  const columns = [
    {
      title: '주문번호',
      width: 80,
      fixed: mediaResult ? '' : 'left',
      dataIndex: 'orderId',
      key: 'orderId',
      ellipsis: true,
      align: 'right',
      // sorter: (a, b) => {},
      render: (value, record) => {
        return (
          <span
            className={`${styles['recommend-inquiry-list-title']}`}
            onClick={() => {
              setOrderDetail(record)
              setIsOrderModalOpen(true)
            }}
          >
            {value}
          </span>
        )
      },
    },
    {
      title: '상품주문번호',
      width: 90,
      dataIndex: 'orderDetailId',
      key: 'orderDetailId',
      fixed: mediaResult ? '' : 'left',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '결제일',
      width: 160,
      dataIndex: 'paymentCreatedAt',
      key: 'paymentCreatedAt',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '구매확정일',
      width: 160,
      dataIndex: 'completeDate',
      key: 'completeDate',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = dayjs(value).format('YYYY.MM.DD. HH:mm')
          return date
        }
      },
    },
    {
      title: '상품번호',
      // width: 200,
      dataIndex: 'productId',
      key: 'productId',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '상품명',
      width: 180,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '옵션명',
      width: 200,
      dataIndex: 'optionTitle',
      key: 'optionTitle',
      ellipsis: true,
    },
    {
      title: '수량',
      // width: 90,
      dataIndex: 'quantity',
      key: 'quantity',
      ellipsis: true,
      align: 'right',
    },
    {
      title: '상품별 총 주문금액',
      // width: 150,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      ellipsis: true,
      align: 'right',
      render: (value) => {
        return value.toLocaleString()
      },
    },
    {
      title: '주문상태',
      width: 90,
      dataIndex: 'orderDetailStatus',
      key: 'orderDetailStatus',
      ellipsis: true,
      render: (value, record) => {
        if (
          Object.prototype.hasOwnProperty.call(record, 'isDeposit') &&
          record.isDeposit &&
          value === 'ready'
        ) {
          return '무통장 입금대기'
        } else {
          return statusUtil.orderStatusChange(value)
        }
      },
    },
    {
      title: `당영 관리 수수료`,
      // width: 200,
      dataIndex: 'brandFeeRate',
      key: 'brandFeeRate',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          if (!record.isCooperate) {
            if (value) {
              const brandFee = record.includeBrandFeeVat ? value * 1.1 : value
              return (
                '-' +
                Math.round(
                  record.totalPrice * (brandFee / 100),
                ).toLocaleString()
              )
            } else {
              return 0
            }
          } else {
            // 공동구매 시 - 당영 관리 수수료 11% 추가 제외
            if (record.useDyCommission && value) {
              const brandFee = record.includeBrandFeeVat ? value * 1.1 : value
              return (
                '-' +
                Math.floor(
                  record.totalPrice * (brandFee / 100),
                ).toLocaleString()
              )
            } else {
              return 0
            }
          }
        } else {
          return 0
        }
      },
    },
    {
      title: `매출 연동 수수료\n(VAT 포함)`,
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          if (value.query) {
            return record.totalPrice * ((record.commissionRate * 1.1) / 100) > 0
              ? '-' +
                  Math.floor(
                    record.totalPrice * ((record.commissionRate * 1.1) / 100),
                  ).toLocaleString()
              : 0
          } else {
            return 0
          }
        } else {
          return 0
        }
      },
    },
    {
      title: '구매 경로',
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'center',
      render: (value, record) => {
        let path = ''
        if (value.query) {
          if (record.isCooperate) {
            path = '공동구매'
          } else {
            if (record?.isManual) {
              path = '전화주문-'
            }
            if (
              record?.influencerRole === 'super_admin' ||
              record?.influencerRole === 'level_1'
            ) {
              path += '인플루언서'
            } else {
              path += '셀러'
            }
          }
        } else if (record?.isManual) {
          path = '전화주문'
        } else {
          path = '검색'
        }
        return path
      },
    },
    {
      title: '택배사',
      width: 180,
      dataIndex: 'deliveryCompany',
      key: 'deliveryCompany',
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <Select
                className={`${styles['order-delivery-company-select']}`}
                placeholder="선택"
                value={editDeliveryInfo[record.orderDetailId].deliveryCompany}
                onChange={(value, e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.id]: {
                      ...editDeliveryInfo[e.id],
                      deliveryCompany: value,
                    },
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Select.Option
                    key={`delivery_company_select_${idx}`}
                    id={record.orderDetailId}
                    value={deliveryCompany.deliveryCompanyId}
                  >
                    {deliveryCompany.deliveryCompanyName}
                  </Select.Option>
                ))}
              </Select>
            )
          } else {
            if (value === null || value === '') {
              return value
            } else {
              const findDeliveryCompany = deliveryCompanyList.find(
                (deliveryCompany) =>
                  deliveryCompany.deliveryCompanyId === value,
              )
              if (findDeliveryCompany) {
                return findDeliveryCompany.deliveryCompanyName
              } else {
                return value
              }
            }
          }
        } else {
          if (value === null || value === '') {
            return value
          } else {
            const findDeliveryCompany = deliveryCompanyList.find(
              (deliveryCompany) => deliveryCompany.deliveryCompanyId === value,
            )
            if (findDeliveryCompany) {
              return findDeliveryCompany.deliveryCompanyName
            } else {
              return value
            }
          }
        }
      },
    },
    {
      title: '송장번호',
      width: 200,
      dataIndex: 'trackingNumber',
      key: 'trackingNumber',
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <Input
                className={`${styles['order-tracking-number-input']}`}
                name={record.orderDetailId}
                value={editDeliveryInfo[record.orderDetailId].trackingNumber}
                onChange={(e) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [e.target.name]: {
                      ...editDeliveryInfo[e.target.name],
                      trackingNumber: e.target.value,
                    },
                  })
                }
              />
            )
          } else {
            return value
          }
        } else {
          return value
        }
      },
    },
    {
      title: '발송일',
      width: 160,
      dataIndex: 'shipDate',
      key: 'shipDate',
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (
          record.orderDetailStatus === 'delivery_ready' ||
          record.orderDetailStatus === 'delivery_shipping'
        ) {
          if (selectedRowKey.includes(record.orderDetailId)) {
            return (
              <DatePicker
                className={`${styles['order-ship-date-input']}`}
                format="YYYY-MM-DD"
                value={editDeliveryInfo[record.orderDetailId].shipDate}
                onChange={(value) =>
                  setEditDeliveryInfo({
                    ...editDeliveryInfo,
                    [record.orderDetailId]: {
                      ...editDeliveryInfo[record.orderDetailId],
                      shipDate: value,
                    },
                  })
                }
              />
            )
          } else {
            if (value === null || value === '') {
              return value
            } else {
              const date = dayjs(value).format('YYYY.MM.DD')
              return date
            }
          }
        } else {
          if (value === null || value === '') {
            return value
          } else {
            const date = dayjs(value).format('YYYY.MM.DD')
            return date
          }
        }
      },
    },
    {
      title: '수취인명',
      width: 90,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (value, row) => {
        if (row.isGift) {
          if (row.giftToName) {
            return row.giftToName
          }
        } else {
          if (value) {
            return value
          }
        }
      },
    },
    {
      title: '구매자명',
      width: 90,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (value, row) => {
        if (row.isGift) {
          return row.giftFromName
        } else {
          if (value) {
            let name = value?.trim().replace(' ', '')
            if (name?.length < 3) {
              return name?.slice(0, 1) + '*'
            } else {
              return name?.slice(0, 1) + '*' + name?.charAt(name?.length - 1)
            }
          } else {
            return null
          }
        }
      },
    },
    {
      title: '연락처',
      // width: 90,
      dataIndex: 'phone',
      key: 'phone',
      ellipsis: true,
    },
    {
      title: '주소',
      // width: 90,
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: '상세주소',
      // width: 90,
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      ellipsis: true,
    },
    {
      title: `정산 금액`,
      // width: 200,
      dataIndex: '',
      key: '',
      ellipsis: true,
      align: 'right',
      render: (value, record) => {
        if (
          record.orderDetailStatus !== 'ready' &&
          record.orderDetailStatus !== 'cancel_request' &&
          record.orderDetailStatus !== 'return_request' &&
          record.orderDetailStatus !== 'return_receive' &&
          record.orderDetailStatus !== 'return_collection' &&
          record.orderDetailStatus !== 'return_collection_complete' &&
          record.orderDetailStatus !== 'cancel_complete' &&
          record.orderDetailStatus !== 'return_complete'
        ) {
          let returnPrice = record.totalPrice
          if (record.isCooperate) {
            returnPrice =
              returnPrice -
              Math.round(
                record.totalPrice * ((record.commissionRate * 1.1) / 100),
              )
            // 공동구매 시 - 당영 관리 수수료 반영 여부에 따라 처리
            if (record.useDyCommission && record.brandFeeRate) {
              const brandFee = record.includeBrandFeeVat
                ? record.brandFeeRate * 1.1
                : record.brandFeeRate
              returnPrice =
                returnPrice - Math.floor(record.totalPrice * (brandFee / 100))
            }
          } else {
            // 매출연동수수료 제외
            if (record.query) {
              returnPrice =
                returnPrice -
                Math.floor(
                  record.totalPrice * ((record.commissionRate * 1.1) / 100),
                )
            }
            // 당영관리수수료 제외
            if (record.brandFeeRate) {
              const brandFee = record.includeBrandFeeVat
                ? record.brandFeeRate * 1.1
                : record.brandFeeRate
              returnPrice =
                returnPrice - Math.floor(record.totalPrice * (brandFee / 100))
            }
          }
          return returnPrice.toLocaleString() + '원'
        } else {
          return 0
        }
      },
    },
    {
      title: '처방전 상태',
      // width: 90,
      dataIndex: 'prescriptionStatus',
      key: 'prescriptionStatus',
      ellipsis: true,
      render: (status) => {
        // null이나 undefined인 경우 처리
        if (status === null || status === undefined) {
          return (
            <Tag
              color="#6D747A"
              style={{
                color: '#FFF',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center',
                // display: 'flex',
              }}
            >
              -
            </Tag>
          )
        }

        const statusConfig = {
          SUBMITTED: { text: '처방전 제출', color: '#F59E0B' },
          PURCHASED: { text: '구매완료', color: '#117FFA' },
          ADMIN_APPROVED: { text: '관리자 승인', color: '#00A4FF' },
          ADMIN_REJECTED: { text: '관리자 반려', color: '#EB516F' },
          REJECTED: { text: '공단 반려', color: '#EB516F' },
          FINALIZED: { text: '최종 완료', color: '#00A4FF' },
        }

        const config = statusConfig[status] || {
          text: status,
          color: '#6D747A',
        }

        return (
          <Tag
            color={config.color}
            style={{ color: '#FFF', fontWeight: 'bold', textAlign: 'center' }}
          >
            {config.text}
          </Tag>
        )
      },
    },
  ]

  const [propsType, setPropsType] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const matchQueryList = window.matchMedia('all and (max-width: 768px)')
      setMediaResult(matchQueryList.matches)

      const media = function handleChange(e) {
        setMediaResult(e.matches)
      }

      matchQueryList.addEventListener('change', media)
    }
  }, [])

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize))
  }, [offset, pageSize])

  useEffect(() => {
    handleChangePagination(currentPageNumber)
  }, [pageSize])

  useEffect(() => {
    if (propsType) {
      getUserOrderList()
    }
  }, [orderType, orderBy])

  useEffect(() => {
    const type = searchParams.get('type')
    // console.log('type:', type)
    if (!propsType) {
      setIsLoading(true)
      if (type) {
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().subtract(14, 'd'),
          searchStatus: type,
        })
        setDateType('')
        setPropsType(true)
        getUserOrderListType(type)
      } else {
        getUserOrderList('initial')
        setPropsType(true)
      }
      getDeliveryCompanyList()
    }
  }, [searchParams, propsType, orderType, orderBy])

  const getUserOrderListType = async (type) => {
    const param = {
      offset: 0,
      pageSize: 10,
      pageType: 'order',
      searchType: searchDateItems[0].searchType,
      startDate: dayjs()
        .subtract(14, 'd')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
      endDate: dayjs().endOf('day').endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      searchStatus: type,
      searchOrderId: null,
      searchProductName: searchOptions.searchProductName,
      funnel: 0,
      name: '',
      phone: '',
      orderType: 'paymentCreatedAt',
      orderBy: 'desc',
      searchDetailType: '',
      searchDetail: '',
      settlementId: null,
    }
    const res = await orderApi.searchOrderDetailList(param, user.id)
    if (res.data.code === 200) {
      if (res.data.result.userOrderDetailDTOList?.length > 1) {
        if (orderType === 'createdAt') {
          if (orderBy === 'desc') {
            res.data.result.userOrderDetailDTOList.sort(
              (a, b) => dayjs(b.createdAt) - dayjs(a.createdAt),
            )
          } else {
            res.data.result.userOrderDetailDTOList.sort(
              (a, b) => dayjs(a.createdAt) - dayjs(b.createdAt),
            )
          }
        }
      }
      setTotalOrderList(res.data.result.userOrderDetailDTOList)
      setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
      if (res.data.result?.length !== 0) {
        setTotalSize(res.data.result.totalCnt)
      }
    }
    setIsLoading(false)
  }

  const getDeliveryCompanyList = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.deliveryCompanyList(user.id)
      if (res.data.code === 200) {
        setDeliveryCompanyList(res.data.result)
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getDeliveryCompanyList read error', error)
    }
  }

  const getUserOrderList = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'order',
          searchType: searchDateItems[0].searchType,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: orderStatusItems[1].value,
          searchOrderId: null,
          searchProductName: '',
          funnel: 0,
          name: '',
          phone: '',
          orderType: 'paymentCreatedAt',
          orderBy: 'desc',
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          pageType: 'order',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          pageType: 'order',
          searchType: searchOptions.searchType,
          startDate: searchOptions.startDate
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          endDate: searchOptions.endDate
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss'),
          searchStatus: searchOptions.searchStatus,
          searchOrderId: searchOptions.searchOrderId,
          searchProductName: searchOptions.searchProductName,
          funnel: searchOptions.funnel,
          name: searchOptions.name,
          phone: searchOptions.phone.includes('-')
            ? searchOptions.phone.replaceAll('-', '')
            : searchOptions.phone,
          orderType: orderType,
          orderBy: orderType,
          searchDetailType: '',
          searchDetail: '',
          settlementId: null,
        }
      }
      const res = await orderApi.searchOrderDetailList(param, user.id)
      // console.log('searchOrderDetailList res', res)
      if (res.data.code === 200) {
        if (res.data.result.userOrderDetailDTOList?.length > 1) {
          if (orderType === 'createdAt') {
            if (orderBy === 'desc') {
              res.data.result.userOrderDetailDTOList.sort(
                (a, b) => dayjs(b.createdAt) - dayjs(a.createdAt),
              )
            } else {
              res.data.result.userOrderDetailDTOList.sort(
                (a, b) => dayjs(a.createdAt) - dayjs(b.createdAt),
              )
            }
          }
        }
        // setTotalOrderList(res.data.result.userOrderDetailDTOList)
        setTotalOrderList([...res.data.result.userOrderDetailDTOList].reverse())
        if (type === 'initial' || type === 'search') {
          // setOrderList(res.data.result.userOrderDetailDTOList.slice(0, 10))
          setOrderList(
            [...res.data.result.userOrderDetailDTOList].reverse().slice(0, 10),
          )
        } else {
          // setOrderList(
          //   res.data.result.userOrderDetailDTOList.slice(
          //     offset,
          //     offset + pageSize,
          //   ),
          // )
          setOrderList(
            [...res.data.result.userOrderDetailDTOList]
              .reverse()
              .slice(offset, offset + pageSize),
          )
        }
        if (res.data.result?.length !== 0) {
          setTotalSize(res.data.result.totalCnt)
        } else {
          setTotalSize(0)
        }
      } else {
        alert(
          '해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getUserOrderList read error', error)
    }
  }

  const changeOrderStatus = async (orderStatus) => {
    setIsLoading(true)
    try {
      let res
      if (orderStatus === 'delivery_shipping') {
        const result = deliveryInfoValidation()
        if (result) {
          const param = {
            userOrderDetailDTOList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => {
                if (deliveryInfo?.shipDate) {
                  return {
                    ...deliveryInfo,
                    shipDate: dayjs(deliveryInfo.shipDate).format(
                      'YYYY-MM-DD HH:mm:ss',
                    ),
                  }
                } else return deliveryInfo
              },
            ),
          }
          // console.log('param', param)
          res = await orderApi.orderTrackingNumRegister(param, user.id)
          console.log('changeOrderStatus-orderTrackingNumRegister res', res)
        } else {
          alert('배송지 및 송장번호를 입력하지 않는 항목이 있습니다.')
          throw 'not valid'
        }
      } else {
        const orderIdSet = new Set(
          selectedRow.map((selectedRow) => selectedRow.orderId),
        )
        const editOrderList = {
          orderIdList: [...orderIdSet],
          orderDetailIdList: selectedRowKey,
          orderStatus: orderStatus,
        }
        res = await orderApi.orderStatusEdit(editOrderList, user.id)
      }
      console.log('orderStatusEdit res', res)
      if (res.data.code === 200 || res.code === 200) {
        console.log('성공 반영')
        if (orderStatus === 'delivery_shipping') {
          const orderIdSet = new Set(
            Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.orderId,
            ),
          )
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: Object.values(editDeliveryInfo).map(
              (deliveryInfo) => deliveryInfo.orderDetailId,
            ),
            orderStatus: orderStatus,
          }
          await sendKakaoAlert(orderParam)
        }
        alert('해당 내용이 성공적으로 반영되었습니다.')
        setSelectedRowKey([])
        setSelectedRow([])
        getUserOrderList()
      } else if (
        res.code === 999 ||
        res.code === 405 ||
        res.data.code === 999 ||
        res.data.code === 405
      ) {
        console.log('오류?', res.data)
        alert(res.data.msg)
      } else {
        console.log(res.data.msg)
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('changeOrderStatus edit error', error)
    }
  }

  // res.data.code - 033125
  const editCustomerDeliveryInfo = async () => {
    setIsLoading(true)
    try {
      const res = await orderApi.orderDeliveryInfoEdit(
        customerDeliveryInfo,
        user.id,
      )
      console.log('resddddddeditCustomerDeliveryInfo', res)
      if (res.code === 200 || res.data.code === 200) {
        alert('해당 내용이 성공적으로 반영되었습니다.')
      } else if (res.data.code === 999) {
        alert(res.data.msg)
      } else {
        alert(
          '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('editCustomerDeliveryInfo edit error', error)
    }
  }

  /**
   * 배송 시작 안내 알림톡 보내기
   */
  const sendKakaoAlert = async (orderParam) => {
    try {
      const res = await pushApi.kakaoForDelivery(orderParam, user.id)
      // console.log('sendKakaoAlert', res)
      if (res.data.code !== 200) {
        alert(
          '선택한 주문건들에 대해 카카오알림톡을 보내는데 실패하였습니다.\n관리자에게 문의해주시길 바랍니다.',
        )
      } else {
        console.log('sendKakaoAlert success', res.data.result)
      }
    } catch (error) {
      setIsLoading(false)
      console.log('sendKakaoAlert alert error', error)
    }
  }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      setIsLoading(true)
      let excelData
      if (selectedRow?.length !== 0) {
        excelData = selectedRow.map((row) => {
          // 당영 관리 수수료
          let commission_dy = row.isCooperate
            ? row?.useDyCommission && row?.brandFeeRate
              ? Math.floor(
                  row.totalPrice *
                    ((row?.includeBrandFeeVat
                      ? row?.brandFeeRate * 1.1
                      : row?.brandFeeRate) /
                      100),
                )
              : 0
            : row?.brandFeeRate
              ? Math.floor(
                  row.totalPrice *
                    ((row?.includeBrandFeeVat
                      ? row?.brandFeeRate * 1.1
                      : row?.brandFeeRate) /
                      100),
                )
              : 0
          // 매출 연동 수수료
          let commission_sell = row.query
            ? Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            : 0

          // 예상 수익
          let profit_price = row.totalPrice
          if (row.isCooperate) {
            profit_price =
              profit_price -
              Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            if (row?.useDyCommission && row?.includeBrandFeeVat) {
              const brandFee = row?.includeBrandFeeVat
                ? row?.brandFeeRate * 1.1
                : row?.brandFeeRate
              profit_price -= Math.floor(row.totalPrice * (brandFee / 100))
            }
          } else {
            if (row.query) {
              profit_price =
                profit_price -
                Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            }
            if (row?.includeBrandFeeVat) {
              const brandFee = row?.includeBrandFeeVat
                ? row?.brandFeeRate * 1.1
                : row?.brandFeeRate
              profit_price -= Math.floor(row.totalPrice * (brandFee / 100))
            }
          }
          let purchase_path = ''
          if (row.query) {
            if (row.isCooperate) {
              purchase_path = '공동구매'
            } else {
              if (row?.isManual) {
                purchase_path = '전화주문-'
              }
              if (
                row?.influencerRole === 'super_admin' ||
                row?.influencerRole === 'level_1'
              ) {
                purchase_path += '인플루언서'
              } else {
                purchase_path += '셀러'
              }
            }
          } else if (row?.isManual) {
            purchase_path = '전화주문'
          } else {
            purchase_path = '검색'
          }
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
            purchasePath: purchase_path,
            commissionDy: commission_dy,
            commissionSell: commission_sell,
            profitPrice: profit_price,
          }
        })
      } else if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          // 당영 관리 수수료
          let commission_dy = row.isCooperate
            ? row?.useDyCommission && row?.brandFeeRate
              ? Math.floor(
                  row.totalPrice *
                    ((row?.includeBrandFeeVat
                      ? row?.brandFeeRate * 1.1
                      : row?.brandFeeRate) /
                      100),
                )
              : 0
            : row?.brandFeeRate
              ? Math.floor(
                  row.totalPrice *
                    ((row?.includeBrandFeeVat
                      ? row?.brandFeeRate * 1.1
                      : row?.brandFeeRate) /
                      100),
                )
              : 0
          // 매출 연동 수수료
          let commission_sell = row.query
            ? Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            : 0

          // 예상 수익
          let profit_price = row.totalPrice
          if (row.isCooperate) {
            profit_price =
              profit_price -
              Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            if (row?.useDyCommission && row?.includeBrandFeeVat) {
              const brandFee = row?.includeBrandFeeVat
                ? row?.brandFeeRate * 1.1
                : row?.brandFeeRate
              profit_price -= Math.floor(row.totalPrice * (brandFee / 100))
            }
          } else {
            if (row.query) {
              profit_price =
                profit_price -
                Math.round(row.totalPrice * ((row.commissionRate * 1.1) / 100))
            }
            if (row?.includeBrandFeeVat) {
              const brandFee = row?.includeBrandFeeVat
                ? row?.brandFeeRate * 1.1
                : row?.brandFeeRate
              profit_price -= Math.floor(row.totalPrice * (brandFee / 100))
            }
          }
          let purchase_path = ''
          if (row.query) {
            if (row.isCooperate) {
              purchase_path = '공동구매'
            } else {
              if (row?.isManual) {
                purchase_path = '전화주문-'
              }
              if (
                row?.influencerRole === 'super_admin' ||
                row?.influencerRole === 'level_1'
              ) {
                purchase_path += '인플루언서'
              } else {
                purchase_path += '셀러'
              }
            }
          } else if (row?.isManual) {
            purchase_path = '전화주문'
          } else {
            purchase_path = '검색'
          }
          return {
            orderId: `SG${row.orderId}`,
            orderDetailId: `sg${row.orderDetailId}`,
            paymentCreatedAt: dayjs(row.paymentCreatedAt).format(
              'YYYY.MM.DD HH:mm',
            ),
            orderDetailStatus:
              statusUtil.matchingOrderStatus[row.orderDetailStatus],
            // productId: row.productId,
            productId: `SUG-${row.productId}`,
            productName: row.productName,
            // optionId: row.optionId,
            optionId: `sgot-${row.optionId}`,
            optionTitle: row.optionTitle,
            quantity: row.quantity,
            totalPrice: row.totalPrice,
            price: row.price,
            couponDiscountPrice: row.couponDiscountPrice,
            createdByName: row.createdByName,
            usePoint: row.usePoint ? 'Y' : 'N',
            name: row.name,
            phone: row.phone,
            address: row.address
              ? row.address +
                (row.addressDetail ? `, ${row.addressDetail}` : '')
              : '',
            addressRequest:
              row.addressRequest === '배송 시 요청사항을 선택해주세요.'
                ? ''
                : row.addressRequest,
            deliveryCompany: statusUtil.matchingDeliveryCompany[
              row.deliveryCompany
            ]
              ? statusUtil.matchingDeliveryCompany[row.deliveryCompany]
              : row.deliveryCompany,
            trackingNumber: row.trackingNumber,
            shipDate: row.shipDate
              ? dayjs(row.shipDate).format('YYYY.MM.DD')
              : row.shipDate,
            purchasePath: purchase_path,
            commissionDy: commission_dy,
            commissionSell: commission_sell,
            profitPrice: profit_price,
          }
        })
      } else {
        alert(
          '다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.',
        )
        throw 'no data'
      }
      // const firstRow = {
      //   orderId_dk: 'orderId',
      //   order_detail_id: 'order_detail_id',
      //   product_id: 'product_id',
      //   product_name: 'product_name',
      //   option_title_dk: 'option_title',
      //   quantity: 'quantity',
      //   sales_price: 'sales_price',
      //   unit_sales_price: 'unit_sales_price',
      //   delivery_company: 'delivery_company',
      //   tracking_number_dk: 'tracking_number',
      //   recipient: 'recipient',
      //   contact: 'contact',
      //   phone_dk: 'phone',
      //   postal_code: 'postal_code',
      //   address_dk: 'address',
      //   address_request_dk: 'address_request',
      //   delivery_price_dk: 'delivery_price',
      //   num_of_tracking_number: 'num_of_tracking_number',
      //   commission_dy: 'commission_dy',
      //   commission_sell: 'commission_sell',
      //   profit_price: 'profit_price',
      // }
      // excelData = [firstRow].concat(excelData)

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet(excelData)
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 })
        ws[cellAdd].v = statusUtil.matchingKey[key]
      })
      XLSX.utils.book_append_sheet(wb, ws, '주문조회')
      XLSX.writeFile(wb, `${dayjs().format('YYYYMMDD')}_주문조회.xlsx`)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      if (error !== 'no data') {
        alert(error)
      }
      console.log('handleExcelDownloadClick edit error', error)
    }
  }

  /**
   * 엑셀 일괄 발송처리 > 업로드된 엑셀 읽기
   */
  const readExcelData = (e) => {
    if (e.target.value !== '') {
      let reader = new FileReader()
      reader.onload = () => {
        let fileData = reader.result
        let wb = XLSX.read(fileData, {
          type: 'binary',
          cellDates: true,
          dateNF: 'YYYY-MM-DD',
        })
        let sheetNameList = wb.SheetNames
        let firstSheet = wb.Sheets[sheetNameList[0]]

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false })
        setUploadExcelData(data)
        setUploadExcelName(e.target.files[0]?.name)
      }
      reader.readAsBinaryString(e.target.files[0])
    } else {
      setUploadExcelData([])
      setUploadExcelName('')
    }
  }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setCurrentPageNumber(1)
        setSelectedRowKey([])
        setSelectedRow([])
        getUserOrderList('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: '',
      searchProductName: '',
      funnel: 0,
      name: '',
      phone: '',
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
    })
    setDateType(dateTypeItems[1].value)
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    setSelectedRowKey([])
    setSelectedRow([])
    getUserOrderList('initial')
  }

  const deliveryInfoValidation = () => {
    const validResult = Object.values(editDeliveryInfo).map((deliveryInfo) => {
      if (
        deliveryInfo.deliveryCompany === null ||
        deliveryInfo.deliveryCompany === '' ||
        deliveryInfo.trackingNumber === null ||
        deliveryInfo.trackingNumber === '' ||
        deliveryInfo.shipDate === null ||
        deliveryInfo.shipDate === ''
      ) {
        return false
      } else {
        return true
      }
    })
    return validResult.every((valid) => valid)
  }

  const customerDeliveryInfoSetting = () => {
    if (
      selectedRow[0].orderDetailStatus === 'delivery_ready' ||
      selectedRow[0].orderDetailStatus === 'paid'
    ) {
      setCustomerDeliveryInfo({
        id: selectedRow[0].orderId,
        name: selectedRow[0].name,
        address: selectedRow[0].address,
        addressDetail: selectedRow[0].addressDetail,
        phone: selectedRow[0].phone,
        postalCode: selectedRow[0].postalCode,
      })
      setIsModalOpen(true)
    } else {
      alert(
        '배송지 정보 수정은 발송처리 이전까지만 가능합니다.\n선택하신 주문 건은 발송처리가 진행되어 배송지 수정이 불가능합니다.',
      )
    }
  }

  const handleDeliveryInfoChange = (e) => {
    const { name, value } = e.target
    setCustomerDeliveryInfo({ ...customerDeliveryInfo, [name]: value })
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('paymentCreatedAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(currOffset)
  }

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize)
    setOffset((current - 1) * pageSize)
  }

  /**
   * 고객 배송지 정보수정 Modal click OK handler
   */
  const handleOk = async () => {
    if (
      customerDeliveryInfo.name === null ||
      customerDeliveryInfo.name === '' ||
      customerDeliveryInfo.address === null ||
      customerDeliveryInfo.address === ''
    ) {
      alert(
        '정보 수정하는데 필요한 값들이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.',
      )
    } else {
      await editCustomerDeliveryInfo()
      setCustomerDeliveryInfo({})
      setSelectedRowKey([])
      setSelectedRow([])
      setIsModalOpen(false)
      getUserOrderList()
    }
  }

  /**
   * 고객 배송지 정보수정 Modal click cancel handler
   */
  const handleCancel = () => {
    setCustomerDeliveryInfo({})
    setIsModalOpen(false)
  }

  /**
   * 송장엑셀업로드 Modal click cancel handler
   */
  const handleExcelUploadCancel = () => {
    setUploadExcelDataHeader([])
    setUploadExcelData([])
    setUploadExcelName('')
    setIsDeliveryShippingModalOpen(false)
    setValidation(false)
    setUploadExcelDataError([])
  }

  /**
   * 송장엑셀 재등록
   */
  const handleExcelReUpload = () => {
    setUploadExcelDataHeader([])
    setUploadExcelData([])
    setUploadExcelName('')
    setValidation(false)
    setUploadExcelDataError([])
  }

  // useEffect(() => {
  //   console.log('selectedRow', selectedRow)
  // }, [selectedRow])

  const orderDirectlyCancel = async () => {
    setIsLoading(true)
    try {
      // 부분환불처리시 포인트 사용 주문에 관한 부분환불은 추가 로직이 필요함.
      // 회사 입장에서 포인트를 먼저 돌려주는 것이 더 이득임.
      if (selectedRow[0].usePoint !== null && selectedRow[0].usePoint !== 0) {
        const isLastOrderParam = {
          id: selectedRow[0].orderId,
          orderDetailIdList: selectedRowKey,
        }
        const isLastOrderRes = await orderApi.isLastOrderByOrderId(
          isLastOrderParam,
          user.id,
        )
        if (isLastOrderRes.data.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`
        }
      }
      let orderDetailIdList = []
      let totalSum = 0
      for (const row of selectedRow) {
        orderDetailIdList.push(row.orderDetailId)
        totalSum += row.totalPrice
      }
      const param = {
        id: selectedRow[0].orderId,
        orderDetailIdList: orderDetailIdList,
        cancelRequestAmount: totalSum,
      }
      const res = await orderApi.refundableOrder(param, user.id)
      if (res.data.code === 200) {
        if (res.data.result) {
          if (
            window.confirm(
              `주문번호: ${selectedRow[0].orderId} 인 주문건에 대한 환불처리가 가능합니다.\n확인을 눌러 환불처리를 이어서 진행해주세요.`,
            )
          ) {
            setIsCancelModalOpen(true)
          }
        } else {
          alert(
            '해당 주문건을 취소하는데 추가 결제 금액이 발생합니다.\n구매자분께서 추가 결제를 진행할 수 있도록 안내 메시지 작성을 부탁드립니다.',
          )
          setEditCancelReason({
            ...editCancelReason,
            cancelReason: '추가 결제 금액 발생',
            refundBank: null,
          })
          setIsCancelRequestModalOpen(true)
        }
      } else {
        throw res.data.msg
      }
    } catch (e) {
      setIsLoading(false)
      console.log('orderDirectlyCancel error', e)
      alert(e)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 구매자에게 취소 요청 보내기 Modal click cancel handler
   */
  const handelRequestModalCancel = () => {
    setEditCancelReason({ cancelReason: null, refundBank: null })
    setSelectedRow([])
    setSelectedRowKey([])
    setIsCancelRequestModalOpen(false)
  }

  /**
   * 구매자에게 취소 요청 보내기 Modal ok handler
   */
  const handleRequestModalOk = async () => {
    setIsLoading(true)
    try {
      const valid = handleSellerCancelValidation()
      if (valid) {
        for (const row of selectedRow) {
          const cancelInfo = {
            orderId: row.orderId,
            orderDetailId: row.orderDetailId,
            orderDetailStatus: 'cancel_request',
            cancelReason: editCancelReason.cancelReason,
            cancelReasonDetail:
              Object.prototype.hasOwnProperty.call(
                editCancelReason,
                'cancelReasonDetail',
              ) &&
              editCancelReason.cancelReasonDetail !== null &&
              editCancelReason.cancelReasonDetail !== ''
                ? editCancelReason.cancelReasonDetail
                : '',
            cancelRequestUser: 'ADMIN',
            // refundHolder: '',
            // refundBank: '',
            // refundAccount: '',
          }
          const cancelRes = await orderApi.orderCancelInfoEdit(
            cancelInfo,
            user.id,
          )
          if (cancelRes.data.code !== 200) {
            setTimeout(() => {
              handelRequestModalCancel()
            }, 1000)
            if (cancelRes.data.code === 999) {
              throw cancelRes.data.msg
            } else {
              throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
            }
          }
        }
        alert('해당 내용을 성공적으로 요청완료했습니다.')
        getUserOrderList()
      } else {
        throw '필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.'
      }
      setIsLoading(false)
      setTimeout(() => {
        handelRequestModalCancel()
      }, 1000)
    } catch (e) {
      setIsLoading(false)
      console.log('handleRequestModalOk error', e)
      alert(e)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 판매자 직접취소 처리 Modal click cancel handler
   */
  const handelSellerModalCancel = () => {
    setEditCancelReason({ cancelReason: null, refundBank: null })
    setSelectedRow([])
    setSelectedRowKey([])
    setIsCancelModalOpen(false)
  }

  /**
   * 판매자 직접취소 처리 Modal click ok handler
   */
  const handleSellerModalOk = async () => {
    setIsLoading(true)
    try {
      const valid = handleSellerCancelValidation()
      if (valid) {
        let totalPriceSum = 0
        let cancelInfoList = []
        let cancelCouponIdList = []
        let cancelParam = {}
        let cancelPointParam = {}
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.sellerId)),
        ]
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.sellerId === sellerId,
          )
          let isLastOrderParam = {
            sellerId: sellerId,
            id: orderBySeller[0].orderId,
            orderDetailIdList: orderBySeller.map(
              (order) => order.orderDetailId,
            ),
          }
          const isLastOrderRes = await orderApi.isLastOrder(
            isLastOrderParam,
            user.id,
          )
          if (isLastOrderRes.data.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.totalPrice
            if (order.couponId !== null) {
              cancelCouponIdList.push(order.couponId)
            }
            const cancelInfo = {
              orderId: order.orderId,
              orderDetailId: order.orderDetailId,
              orderDetailStatus: 'cancel_complete',
              cancelReason: editCancelReason.cancelReason,
              cancelReasonDetail:
                Object.prototype.hasOwnProperty.call(
                  editCancelReason,
                  'cancelReasonDetail',
                ) &&
                editCancelReason.cancelReasonDetail !== null &&
                editCancelReason.cancelReasonDetail !== ''
                  ? editCancelReason.cancelReasonDetail
                  : '',
              cancelRequestUser: 'ADMIN',
              refundHolder:
                Object.prototype.hasOwnProperty.call(
                  editCancelReason,
                  'refundHolder',
                ) &&
                editCancelReason.refundHolder !== null &&
                editCancelReason.refundHolder !== ''
                  ? editCancelReason.refundHolder
                  : '',
              refundBank:
                Object.prototype.hasOwnProperty.call(
                  editCancelReason,
                  'refundBank',
                ) &&
                editCancelReason.refundBank !== null &&
                editCancelReason.refundBank !== ''
                  ? editCancelReason.refundBank
                  : '',
              refundAccount:
                Object.prototype.hasOwnProperty.call(
                  editCancelReason,
                  'refundAccount',
                ) &&
                editCancelReason.refundAccount !== null &&
                editCancelReason.refundAccount !== ''
                  ? editCancelReason.refundAccount
                  : '',
            }
            cancelInfoList.push(cancelInfo)
          }
          if (isLastOrderRes.data.result?.length === 0) {
            if (
              orderBySeller[0].deliveryPriceBaseline !== null &&
              totalPriceSum < orderBySeller[0].deliveryPriceBaseline
            ) {
              totalPriceSum += orderBySeller[0].deliveryPrice
            }
          } else {
            let remainPriceSum = 0
            for (const order of isLastOrderRes.data.result) {
              remainPriceSum += order.totalPrice
            }
            if (
              orderBySeller[0].deliveryPriceBaseline !== null &&
              remainPriceSum < orderBySeller[0].deliveryPriceBaseline
            ) {
              totalPriceSum -= orderBySeller[0].deliveryPrice
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].usePoint !== null) {
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].orderId,
              // orderStatus: 'cancel_complete',
            },
          }
          totalPriceSum -= selectedRow[0].usePoint
        }
        if (selectedRow[0].payMethod === 'vbank') {
          cancelParam = {
            merchantUid: selectedRow[0].orderId,
            impUid: selectedRow[0].impUid,
            reason: `[${editCancelReason.cancelReason}] ${
              editCancelReason.cancelReasonDetail
                ? editCancelReason.cancelReasonDetail
                : ''
            }`,
            cancelRequestAmount: totalPriceSum,
            refundHolder: editCancelReason.refundHolder,
            refundBank: editCancelReason.refundBank,
            refundAccount: editCancelReason.refundAccount,
            userOrderDetailList: selectedRow,
          }
        } else {
          cancelParam = {
            merchantUid: selectedRow[0].orderId,
            impUid: selectedRow[0].impUid,
            reason: `[${editCancelReason.cancelReason}] ${
              editCancelReason.cancelReasonDetail
                ? editCancelReason.cancelReasonDetail
                : ''
            }`,
            cancelRequestAmount: totalPriceSum,
            // cancelableAmount: row.totalPrice
            userOrderDetailList: selectedRow,
          }
        }
        const res = await orderApi.orderDirectlyCancel(cancelParam, user.id)
        if (res.data.code === 203) {
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              userCouponIsAvailable: true,
              userId: selectedRow[0].createdBy,
            }
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
              user.id,
            )
            if (cancelCouponRes.data.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
            }
          }
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            const cancelPointRes = await orderApi.purchasePointCancel(
              cancelPointParam,
              user.id,
            )
            if (cancelPointRes.data.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await orderApi.orderCancelInfoEdit(
              cancelInfo,
              user.id,
            )
            if (cancelRes.data.code !== 200) {
              setTimeout(() => {
                handelSellerModalCancel()
              }, 1000)
              if (cancelRes.data.code === 999) {
                throw cancelRes.data.msg
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
              }
            }
          }
        } else {
          setTimeout(() => {
            handelSellerModalCancel()
          }, 1000)
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
        }
        alert('해당 내용이 성공적으로 반영되었습니다.')
        getUserOrderList()
      } else {
        throw '필수값이 채워지지 않았거나 원하는 형식과 다릅니다.\n다시 시도해주시길 바랍니다.'
      }
      setIsLoading(false)
      setTimeout(() => {
        handelSellerModalCancel()
      }, 1000)
    } catch (e) {
      setIsLoading(false)
      console.log('handleSellerModalOk error', e)
      alert(e)
    } finally {
      setIsLoading(false)
    }
  }

  /**
   * 판매자 직접취소 처리 validation
   */
  const handleSellerCancelValidation = () => {
    console.log('취소1')
    if (selectedRow[0].pay_method === 'vbank') {
      console.log('취소2')
      if (
        Object.prototype.hasOwnProperty.call(
          editCancelReason,
          'cancelReason',
        ) &&
        editCancelReason.cancelReason !== null &&
        editCancelReason.cancelReason !== '' &&
        Object.prototype.hasOwnProperty.call(
          editCancelReason,
          'refundHolder',
        ) &&
        editCancelReason.refundHolder !== null &&
        editCancelReason.refundHolder !== '' &&
        editCancelReason.refundHolder === selectedRow[0].name &&
        Object.prototype.hasOwnProperty.call(editCancelReason, 'refundBank') &&
        editCancelReason.refundBank !== null &&
        editCancelReason.refundBank !== '' &&
        Object.prototype.hasOwnProperty.call(
          editCancelReason,
          'refundAccount',
        ) &&
        editCancelReason.refundAccount !== null &&
        editCancelReason.refundAccount !== '' &&
        /^(\s|\d)+$/.test(editCancelReason.refundAccount)
      ) {
        return true
      } else {
        return false
      }
    } else {
      if (
        Object.prototype.hasOwnProperty.call(
          editCancelReason,
          'cancelReason',
        ) &&
        editCancelReason.cancelReason !== null &&
        editCancelReason.cancelReason !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  }

  /**
   * 업로드된 송장 엑셀 유효성 체크
   */
  const handleExcelValidation = async () => {
    setIsLoading(true)
    let isValid = false
    let dataKeys = []
    try {
      if (uploadExcelData?.length > 1) {
        let nonExistentRowList = []
        let orderIdList = []
        let duplicateOrderIdList = []
        dataKeys = uploadExcelData.shift()
        setUploadExcelDataHeader(dataKeys)
        for (const data of uploadExcelData) {
          let validValueList = []
          Object.keys(dataKeys).forEach((key) => {
            switch (key) {
              case '개별상품주문번호':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (orderIdList.includes(data[key])) {
                    duplicateOrderIdList.push(data[key])
                    validValueList.push(true)
                  } else {
                    orderIdList.push(data[key].replace('sg', ''))
                    validValueList.push(true)
                  }
                } else {
                  validValueList.push(false)
                }
                break
              case '택배사':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (
                    Object.values(statusUtil.matchingDeliveryCompany).includes(
                      data[key],
                    )
                  ) {
                    validValueList.push(true)
                  } else {
                    validValueList.push(false)
                  }
                } else {
                  validValueList.push(false)
                }
                break
              case '발송일':
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                  if (typeof data[key] !== 'string') {
                    validValueList.push(false)
                  } else {
                    if (/\d{4}-\d{2}-\d{2}/.test(data[key])) {
                      validValueList.push(true)
                    } else {
                      validValueList.push(false)
                    }
                  }
                }
                break
            }
          })
          if (
            !Object.prototype.hasOwnProperty.call(data, '택배사') ||
            !Object.prototype.hasOwnProperty.call(data, '송장번호')
          ) {
            nonExistentRowList.push(data.__rowNum__ + 1)
          } else {
            if (!validValueList.every((result) => result)) {
              nonExistentRowList.push(data.__rowNum__ + 1)
            }
          }
        }
        if (nonExistentRowList?.length !== 0) {
          throw `${nonExistentRowList.join(
            '행, ',
          )}행의 값이 비어있거나 올바른 형식이 아닙니다.\n올바른 파일을 다시 업로드해주세요`
        } else if (duplicateOrderIdList?.length !== 0) {
          throw `개별주문번호가 ${duplicateOrderIdList.join(
            ', ',
          )}인 행이 중복되어있습니다.\n확인 후 올바른 파일을 다시 업로드해주세요`
        } else {
          const res = await orderApi.isPossibleUploadTrackingNumber(
            {
              orderDetailIdList: orderIdList,
            },
            user.id,
          )
          if (res.data.code === 200) {
            if (res.data.result === 0) {
              setIsLoading(false)
              alert('엑셀 유효성검사가 완료되었습니다.')
              setValidation(true)
              isValid = true
            } else {
              throw '주문항목들 중 주문상태가 배송준비중이거나 배송중이 아닌 항목들이 존재합니다.\n확인 후 올바른 파일을 다시 업로드해주세요'
            }
          } else {
            throw '해당 주문건들에 대한 주문 상태를 확인하는데 실패하였습니다.\n새로고침 후 다시 업로드 진행해주시길 바랍니다.'
          }
        }
      } else {
        throw '업로드할 데이터가 없습니다.\n데이터를 입력하거나 템플릿 수정 후 다시 업로드해주세요'
      }
    } catch (e) {
      setIsLoading(false)
      alert(e)
      setTimeout(() => {
        setUploadExcelDataHeader([])
        setUploadExcelData([])
        let excelInput = document.getElementById('excelFile')
        excelInput.value = ''
        setUploadExcelName('')
        setValidation(false)
      }, 1000)
    } finally {
      setIsLoading(false)
      // eslint-disable-next-line no-unsafe-finally
      return { isValid: isValid, dataKeys: dataKeys }
    }
  }

  /**
   * 송장 업로드 양식으로 데이터 바인딩
   * + 상품주문번호에 DY 지우기 (2023.12.11) - ksb
   * @returns {Promise<{}[]>}
   */
  const trackingNumExcelFormat = async (uploadExcelDataHeader) => {
    const dataFormatting = uploadExcelData.map((excelData) => {
      let returnValue = {}
      Object.keys(uploadExcelDataHeader).forEach((key) => {
        if (key === '택배사') {
          returnValue[uploadExcelDataHeader[key]] = Object.keys(
            statusUtil.matchingDeliveryCompany,
          ).find(
            (companyKey) =>
              statusUtil.matchingDeliveryCompany[companyKey] === excelData[key],
          )
        } else if (key === '발송일') {
          // 엑셀 날짜 형식 한 번 더 포멧
          if (excelData[key]) {
            returnValue[uploadExcelDataHeader[key]] = dayjs(
              excelData[key],
            ).isValid()
              ? dayjs(excelData[key]).format('YYYY-MM-DD HH:mm:ss')
              : dayjs().format('YYYY-MM-DD HH:mm:ss')
          } else {
            returnValue[uploadExcelDataHeader[key]] = dayjs().format(
              'YYYY-MM-DD HH:mm:ss',
            )
          }
        } else if (key === '개별상품주문번호') {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            'sg',
            '',
          )
        } else if (key === '수취인명') {
          /* empty */
        } else if (key === '상품주문번호') {
          returnValue[uploadExcelDataHeader[key]] = excelData[key].replace(
            'SG',
            '',
          )
        } else {
          returnValue[uploadExcelDataHeader[key]] = excelData[key]
        }
      })
      returnValue['orderDetailStatus'] = 'delivery_shipping'
      return returnValue
    })
    return dataFormatting
  }

  /**
   * 송장 엑셀 데이터 formatting
   * + 엑셀 일괄 발송처리 > 등록하기 버튼 클릭 함수 (2023.08.01) - ksb
   */
  const handleExcelUpload = async () => {
    setIsLoading(true)
    let dataFormatting
    const validationResult = await handleExcelValidation()
    if (validationResult.isValid) {
      dataFormatting = await trackingNumExcelFormat(validationResult.dataKeys)
    }

    // 유효성 검사한 엑셀 데이터 DB에 저장
    if (dataFormatting?.length) {
      try {
        const res = await orderApi.orderTrackingNumRegister(
          {
            userOrderDetailDTOList: dataFormatting,
          },
          user.id,
        )
        if (res.data.code === 200 && res.data.result) {
          const orderIdSet = new Set(
            res.data.result.map((deliveryInfo) => deliveryInfo.orderId),
          )
          const orderParam = {
            orderIdList: [...orderIdSet],
            orderDetailIdList: dataFormatting.map((deliveryInfo) =>
              deliveryInfo.orderDetailId.replace('sg', ''),
            ),
            orderStatus: 'delivery_shipping',
          }
          await sendKakaoAlert(orderParam)
          alert('해당 내용이 성공적으로 반영되었습니다.')
          getUserOrderList()
          const timer = setTimeout(() => {
            handleExcelUploadCancel()
          }, 1000)
          return () => {
            clearTimeout(timer)
          }
        } else if (res.data.code === 999 || res.data.code === 405) {
          alert(res.data.msg)
        } else {
          alert(
            '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
          )
        }
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.log('handleExcelUpload edit error', error)
      }
    }
    setIsLoading(false)
  }

  /**
   * Post Code 입력하기 (다음 주소 api)
   * @param data
   */
  const handlePostCode = (data) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }

    if (fullAddress?.length > 0) {
      setCustomerDeliveryInfo({
        ...customerDeliveryInfo,
        postalCode: data.zonecode,
        address: fullAddress,
      })
    }
    setIsPostalCodeModalOpen(false) // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  /**
   * 주문 상세 Modal cancel handler
   */
  const handleOrderDetailModalCancel = () => {
    setIsOrderModalOpen(false)
    setOrderDetail({})
  }

  const disabledDeliveryReady = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every((row) => row.orderDetailStatus === 'paid')
    }
  }

  const disabledDeliveryShipping = () => {
    if (selectedRow?.length === 0) {
      return true
    } else {
      return !selectedRow.every(
        (row) =>
          row.orderDetailStatus === 'delivery_ready' ||
          row.orderDetailStatus === 'delivery_shipping',
      )
    }
  }

  // const disabledAdminCancelComplete = () => {
  //   if (selectedRow?.length === 0) {
  //     return true
  //   } else {
  //     let orderId = 0
  //     let validList = []
  //     for (let i = 0; i < selectedRow?.length; i++) {
  //       const row = selectedRow[i]
  //       if (i === 0) {
  //         orderId = row.orderId
  //         // if (
  //         //   Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
  //         //   row.isDeposit
  //         // ) {
  //         //   validList.push(false)
  //         // } else {

  //         if (
  //           (Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
  //             row.isDeposit &&
  //             row.orderDetailStatus === 'paid') ||
  //           row.orderDetailStatus === 'delivery_ready'
  //         ) {
  //           validList.push(true)
  //         } else {
  //           validList.push(false)
  //         }
  //         // }
  //       } else {
  //         if (row.orderId !== orderId) {
  //           validList.push(false)
  //         } else {
  //           // if (
  //           //   Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
  //           //   row.isDeposit
  //           // ) {
  //           //   validList.push(false)
  //           // } else {

  //           if (
  //             (Object.prototype.hasOwnProperty.call(row, 'isDeposit') &&
  //               row.isDeposit &&
  //               row.orderDetailStatus === 'paid') ||
  //             row.orderDetailStatus === 'delivery_ready'
  //           ) {
  //             validList.push(true)
  //           } else {
  //             validList.push(false)
  //           }
  //           // }
  //         }
  //       }
  //     }
  //     return !validList.every((result) => result)
  //   }
  // }

  const disabledAdminCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true
    }
    // else {
    //   let orderId = 0
    //   let validList = []
    //   for (let i = 0; i < selectedRow?.length; i++) {
    //     const row = selectedRow[i]
    //     if (i === 0) {
    //       orderId = row.order_id
    //       if (row.hasOwnProperty('is_deposit') && row.is_deposit) {
    //         validList.push(true) // 원래 false
    //       } else {
    //         if (row.order_detail_status === 'paid') {
    //           validList.push(true)
    //         } else {
    //           validList.push(false)
    //         }
    //       }
    //     } else {
    //       if (row.order_id !== orderId) {
    //         validList.push(false)
    //       } else {
    //         if (row.hasOwnProperty('is_deposit') && row.is_deposit) {
    //           validList.push(true) // 원래 false
    //         } else {
    //           if (row.order_detail_status === 'paid') {
    //             validList.push(true)
    //           } else {
    //             validList.push(false)
    //           }
    //         }
    //       }
    //     }
    //   }
    //   return !validList.every((result) => result)
    // }
  }

  const handleExcelWithDelivery = async () => {
    getUserOrderList()
    if (
      confirm(`${selectedRow?.length}개의 주문을 발주확인 처리 하시겠습니까?`)
    ) {
      changeOrderStatus('delivery_ready')
      handleExcelDownloadClick()
    }
  }

  const disabledValidationBtn = () => {
    if (uploadExcelData?.length !== 0 && !validation) {
      return false
    } else {
      return true
    }
  }

  return (
    <>
      <ContentHeader title="발주확인/발송관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1080px' }}
      >
        {/* 발주 확인 Quick-Button */}
        <OrderStatusQuickMenu
          searchOptions={searchOptions}
          setSearchOptions={setSearchOptions}
          setDateType={setDateType}
          getUserOrderList={getUserOrderList}
        />
        {/*주문검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: 'left' }}
            >
              {searchDateItems.map((item, idx) => (
                <Select.Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ marginTop: 10, gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, startDate: value })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, endDate: value })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: 'left' }}
            >
              {orderStatusItems.map((item, idx) => (
                <Select.Option
                  key={`order_status_search_${idx}`}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="구매경로"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={funnelStatusItems}
              onChange={(e) =>
                setSearchOptions({ ...searchOptions, funnel: e.target.value })
              }
              value={searchOptions.funnel}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>
                  주문번호
                </div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    if (
                      numberReg.test(e.target.value) ||
                      e.target.value === ''
                    ) {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      })
                    }
                  }}
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>상품명</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>이름</div>
              </Col>
              <Col style={{ marginRight: '2rem' }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className={`${styles['content-search-wrap']}`}>연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: 'left' }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['product-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*주문검색목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className={`${styles['product-register-box-title']}`}>
              주문목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>
            <Button
              style={{ marginLeft: 20 }}
              className={`${styles['order-excel-download-btn']}`}
              onClick={() => setShowWarningModal(true)}
            >
              주의
            </Button>
          </div>
          <div>
            <Button
              className={`${styles['order-excel-download-btn']}`}
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
        >
          <Row align={'middle'} style={{ gap: 10 }}>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledDeliveryReady()}
              onClick={handleExcelWithDelivery}
            >
              <img
                style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
              />
              발주확인 처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledDeliveryReady()}
              onClick={() => changeOrderStatus('delivery_ready')}
            >
              발주확인
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledDeliveryShipping()}
              onClick={() => changeOrderStatus('delivery_shipping')}
            >
              발송처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              onClick={() => setIsDeliveryShippingModalOpen(true)}
            >
              엑셀 일괄 발송처리
            </Button>
            <Button
              className={`${styles['order-status-change-button']}`}
              disabled={disabledAdminCancelComplete()}
              onClick={() => orderDirectlyCancel()}
            >
              판매자 직접취소 처리
            </Button>
          </Row>
          {/* {user?.role === 'super_admin' && (
            <div>
              <Button
                className={`${styles['order-status-change-button']}`}
                onClick={() => navigate('/order/complete')}
              >
                구매확정 후 취소처리 바로가기
                <img
                  style={{ height: 14.2, width: 14.5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/sales/right-arrow-gray.png`}
                />
              </Button>
            </div>
          )} */}
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            padding: '20px 25px 40px',
            height: 'fit-content',
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            // tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="orderDetailId"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: 'max-content' }}
            onChange={tableOnChange}
            pagination={false}
          />

          <Pagination
            showSizeChanger
            pageSize={pageSize}
            onShowSizeChange={pageSizeChange}
            total={totalSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            backgroundColor: '#f8f9fd',
            height: 'fit-content',
            padding: '15px 25px',
            borderTop: 0,
          }}
        >
          <Form.Item
            className={`${styles['order-bottom-form-item']} ${styles['center-label']}`}
            label="주문관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledDeliveryReady()}
                onClick={() => changeOrderStatus('delivery_ready')}
              >
                발주확인
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={selectedRowKey?.length !== 1}
                onClick={customerDeliveryInfoSetting}
              >
                고객 배송지 정보수정
              </Button>
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']}`}
            label="배송관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align={'middle'} style={{ gap: 10 }}>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledDeliveryShipping()}
                onClick={() => changeOrderStatus('delivery_shipping')}
              >
                발송처리
              </Button>
              <Button
                className={`${styles['order-status-change-button']}`}
                onClick={() => setIsDeliveryShippingModalOpen(true)}
              >
                엑셀 일괄 발송처리
              </Button>
            </Row>
            <div style={{ marginTop: 10 }}>
              * 배송사 및 송장번호 입력 후, 발송처리를 눌러주세요. (서식은
              텍스트로 해주세요.)
            </div>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']} ${styles['order-bottom-divider-margin']}`}
          />
          <Form.Item
            className={`${styles['order-bottom-form-item']}`}
            label="반품교환관리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className={`${styles['order-status-change-button']}`}
                disabled={disabledAdminCancelComplete()}
                onClick={() => orderDirectlyCancel()}
              >
                판매자 직접취소 처리
              </Button>
            </Row>
            <div style={{ marginTop: 10 }}>
              * 같은 주문번호에 한해서만 다건처리가 가능합니다. 혹은 하나씩
              선택해주세요.
            </div>
          </Form.Item>
        </div>

        {/*고객배송지정보수정Modal*/}
        {selectedRow?.length !== 0 &&
        Object.keys(customerDeliveryInfo)?.length !== 0 ? (
          <Modal
            title="고객 배송지 정보수정"
            open={isModalOpen}
            centered={true}
            cancelText={<span>취소</span>}
            okText={<span>정보 수정</span>}
            onOk={handleOk}
            onCancel={handleCancel}
            // width={"80%"}
          >
            <Form.Item
              label="수령자명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="name"
                value={customerDeliveryInfo.name}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="연락처"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="phone"
                value={customerDeliveryInfo.phone}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="우편번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Row justify={'space-between'} style={{ width: '100%' }}>
                <Col span={10}>
                  <Input
                    name="postalCode"
                    value={customerDeliveryInfo.postalCode}
                    onChange={handleDeliveryInfoChange}
                  />
                </Col>
                <Col span={'auto'}>
                  <Button onClick={() => setIsPostalCodeModalOpen(true)}>
                    우편번호 검색
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              label="주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="address"
                value={customerDeliveryInfo.address}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
            <Form.Item
              label="상세주소"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input
                name="addressDetail"
                value={customerDeliveryInfo.addressDetail}
                onChange={handleDeliveryInfoChange}
              />
            </Form.Item>
          </Modal>
        ) : null}

        {/*우편번호검색Modal*/}
        {isPostalCodeModalOpen && (
          <Modal
            className="order-postal-code-modal"
            open={isPostalCodeModalOpen}
            onCancel={() => setIsPostalCodeModalOpen(false)}
            footer={null}
          >
            <DaumPostcodeEmbed
              style={{
                height: '450px',
              }}
              submitMode={false}
              onComplete={handlePostCode}
            />
          </Modal>
        )}

        {isDeliveryShippingModalOpen && (
          <Modal
            className="excel-delivery-modal"
            title="엑셀 일괄 발송처리"
            open={isDeliveryShippingModalOpen}
            onCancel={handleExcelUploadCancel}
            footer={null}
          >
            <ExcelUploadBodyComponent
              uploadExcelName={uploadExcelName}
              uploadExcelDataError={uploadExcelDataError}
              handleExcelUpload={handleExcelUpload}
              validation={validation}
              readExcelData={readExcelData}
              handleExcelReUpload={handleExcelReUpload}
              loading={isLoading}
            />
          </Modal>
        )}

        {/*판매자 직접취소 처리*/}
        {isCancelModalOpen && (
          <Modal
            title="선택건 판매취소"
            open={isCancelModalOpen}
            onCancel={handelSellerModalCancel}
            onOk={handleSellerModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>선택건 판매취소</span>}
            confirmLoading={isLoading}
            width={'50%'}
          >
            <Form.Item
              label="판매 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="선택"
                value={editCancelReason.cancelReason}
                onChange={(value) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    cancelReason: value,
                  })
                }
                style={{ width: 250, textAlign: 'left' }}
              >
                {cancelReasonItems.map((item, idx) => (
                  <Select.Option
                    key={`order_cancelReason_${idx}`}
                    value={item.value}
                  >
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancelReasonDetail"
                value={editCancelReason.cancelReasonDetail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
            <Form.Item
              label="예금주"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                placeholder="주문자명과 동일한 예금주명을 입력해주세요"
                name="refundHolder"
                value={editCancelReason.refundHolder}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                disabled={selectedRow[0]?.payMethod !== 'vbank'}
              />
            </Form.Item>
            <Form.Item
              label="환불 은행"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                placeholder="환불 은행을 선택해주세요"
                value={editCancelReason.refundBank}
                onChange={(value) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    refundBank: value,
                  })
                }
                disabled={selectedRow[0]?.payMethod !== 'vbank'}
                title="무통장 입금(가상계좌)일 경우에만 이용할 수 있어요"
              >
                {bankCodeItems.map((item, idx) => (
                  <Select.Option key={`bank_code_${idx}`} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="계좌번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                placeholder={`"-"없이 계좌번호 숫자를 입력해주세요`}
                name="refundAccount"
                value={editCancelReason.refundAccount}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                disabled={selectedRow[0]?.payMethod !== 'vbank'}
              />
            </Form.Item>
          </Modal>
        )}

        {/*구매자에게 취소 요청 보내기*/}
        {isCancelRequestModalOpen && (
          <Modal
            title="선택건 판매취소요청"
            open={isCancelRequestModalOpen}
            onCancel={handelRequestModalCancel}
            onOk={handleRequestModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            width={'50%'}
          >
            <Form.Item
              label="취소 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="cancelReason"
                value={editCancelReason.cancelReason}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancelReasonDetail"
                value={editCancelReason.cancelReasonDetail}
                onChange={(e) =>
                  setEditCancelReason({
                    ...editCancelReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
          </Modal>
        )}

        {/*주문 상세 페이지*/}
        {isOrderModalOpen && (
          <Modal
            title="상품주문정보 조회"
            wrapClassName="order-detail-modal-wrap"
            open={isOrderModalOpen}
            centered={true}
            onCancel={handleOrderDetailModalCancel}
            footer={null}
            width="60%"
          >
            <OrderDetailComponent
              orderDetail={orderDetail}
              handleOrderDetailModalCancel={handleOrderDetailModalCancel}
              getUserOrderList={getUserOrderList}
            />
          </Modal>
        )}

        {/*주의 사항 머달*/}
        {showWarningModal && (
          <Modal
            title="주의사항"
            wrapClassName="order-detail-modal-wrap"
            open={showWarningModal}
            centered={true}
            onCancel={() => setShowWarningModal(false)}
            footer={null}
            width={'50%'}
            // height={'30vh'}
            style={{ height: '30vh', overflowY: 'auto' }}
          >
            <div style={{ height: '100%' }}>
              <strong>엑셀 업로드 시 주의 사항</strong>
              <br></br>
              <p>
                • 송장번호 및 날짜를 입력할 시 엑셀의 서식은{' '}
                <strong>텍스트</strong>로 하셔야 안전합니다.
              </p>
              <p>
                • 옵션을 여러 개 선택했을 경우 주의하여 발주확인/발송처리를
                하셔야 합니다. (옵션을 여러 개 선택하셨을 경우 주문번호는
                고유값으로 여러 줄로 표현될 수 있습니다.)
              </p>
              <p>• 엑셀 유효성 검사를 반드시 수행해주세요.</p>
              <p>
                • 운송장 번호가 제대로 되지 않았을 시 배송 알림이 가지 않으니
                반드시 유의해주세요.
              </p>
            </div>
          </Modal>
        )}
      </div>
    </>
  )
}
export default OrderConfirmPage
